import AmplifyWrapper from '../service/auth.service';

export const SIGNUP = 'SIGNUP';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_ERROR = 'SIGNUP_ERROR';

const requestSignup = (username, password, email, phone) => {
	return {
		type: SIGNUP,
		username,
		password,
		email,
		phone
	};
};

const recieveSignupSuccess = data => {
	return {
		type: SIGNUP_SUCCESS,
		data
	};
};

const recieveSignupError = errors => {
	return {
		type: SIGNUP_ERROR,
		errors
	};
};

export const signup = (username, password, email, phone) => {
	return async function(dispatch) {
		//
		dispatch(requestSignup(username, password, email, phone));
		//
		AmplifyWrapper.signUp(username, password, email, phone)
			.then(data => {
				dispatch(recieveSignupSuccess(data));
			})
			.catch(err => {
				dispatch(recieveSignupError(err));
			});
	};
};
